// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NWQmB","label":"styles_label__3EieH"};